module.exports = __webpack_public_path__ + "static/img/wangping.132e563.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/wangping.jpg
// module id = sDsw
// module chunks = 0